module.exports = __webpack_public_path__ + "img/54cf365.jpg";